<template>
  <v-container class="modern-config-view pb-12">
    <!-- Premium Global Header -->
    <v-row class="mb-8 align-center px-4 pt-4">
      <div class="d-flex align-center">
        <v-avatar color="primary" size="48" class="mr-4 shadow-sm">
          <v-icon color="white">fas fa-cogs</v-icon>
        </v-avatar>
        <div>
          <h1 class="text-h4 font-weight-black primary--text mb-0">Configuración</h1>
          <div class="caption grey--text font-weight-bold text-uppercase tracking-widest mt-1">Gestión de Maestros de Inventario y Stocks</div>
        </div>
      </div>
    </v-row>

    <v-card outlined class="modern-card elevation-0 overflow-hidden">
      <v-tabs 
        v-model="tab"
        background-color="grey lighten-5"
        color="primary"
        grow
        class="border-bottom"
      >
        <v-tab class="text-none font-weight-bold py-4">
          <v-icon left small>fas fa-truck-loading</v-icon>
          Proveedores
        </v-tab>
        <v-tab class="text-none font-weight-bold py-4">
          <v-icon left small>fas fa-tags</v-icon>
          Familias
        </v-tab>
        <v-tab class="text-none font-weight-bold py-4">
          <v-icon left small>fas fa-balance-scale</v-icon>
          Unidades
        </v-tab>
        <v-tab class="text-none font-weight-bold py-4">
          <v-icon left small>fas fa-warehouse</v-icon>
          Bodegas
        </v-tab>
        <v-tab class="text-none font-weight-bold py-4">
          <v-icon left small>fas fa-exchange-alt</v-icon>
          Movimientos
        </v-tab>
        <v-tab class="text-none font-weight-bold py-4">
          <v-icon left small>fas fa-building</v-icon>
          Costos
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item class="pa-6">
          <providers/>
        </v-tab-item>
        <v-tab-item class="pa-6">
          <families/>
        </v-tab-item>
        <v-tab-item class="pa-6">
          <units/>
        </v-tab-item>
        <v-tab-item class="pa-6">
          <stores/>
        </v-tab-item>
        <v-tab-item class="pa-6">
          <tipos/>
        </v-tab-item>
        <v-tab-item class="pa-6">
          <centers/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import Providers from '@/components/stocks/Providers'
import Families from '@/components/stocks/Families'
import Units from '@/components/stocks/Units'
import Stores from '@/components/stocks/Stores'
import Tipos from '@/components/stocks/Tipos'
import Centers from '@/components/stocks/Centers'

export default {
  name: 'StocksConfiguration',
  components: { Families, Units, Stores, Tipos, Centers, Providers },
  data() {
    return {
      tab: 0,
    }
  },
}
</script>

<style scoped>
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 12px !important;
}
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.08) !important; }
.text-none { text-transform: none !important; }
.tracking-widest { letter-spacing: 2px; }
.shadow-sm { box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important; }
</style>